import zhHansMessages from "../locales/zhHans.messages";
import { toNestedMessageIds } from "../utils/locale";

export default toNestedMessageIds(zhHansMessages);
